import EthnicityFields from './EthnicityFields';
import PermissionCheck from '../../Components/PermissionCheck';
import React from 'react';
import Contacts from './Contacts';
import {useSelector} from 'react-redux';
import PROFILE_TYPE from '../../../../../constants/profileTypes';

const contactsPermission = {
    [PROFILE_TYPE.ENQUIRY]: 'EnquiryContacts',
    [PROFILE_TYPE.APPLICATION]: 'ApplicantContacts',
    [PROFILE_TYPE.STUDENT]: 'StudentContacts',
};

const ethnicityPermission = {
    [PROFILE_TYPE.APPLICATION]: 'ApplicantEthnicity',
    [PROFILE_TYPE.STUDENT]: 'StudentEthnicity',
};

const ContactsAndEthnicityTab = () => {
    const personType = useSelector(state => state.profilesInfo.selectedProfile.personType);
    const selectedProfile = useSelector(state => state.profilesInfo.selectedProfile);

    return (
        <>
            <PermissionCheck
                permissionModule={contactsPermission[personType] || ''}
                studentProfile={selectedProfile}
                render={(readonly) => <Contacts readonly={readonly}/>}
            />
            <PermissionCheck
                permissionModule={ethnicityPermission[personType] || ''}
                studentProfile={selectedProfile}
                render={(readonly) => <EthnicityFields readonly={readonly}/>}
            />
        </>
    );
};

export default ContactsAndEthnicityTab;